/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useState, useEffect } from "react";
import { Link, useHistory } from "react-router-dom";
import { useSelector, shallowEqual, connect, useDispatch } from "react-redux";
import { useFormik } from "formik";
import * as Yup from "yup";
import SVG from "react-inlinesvg";
import { ModalProgressBar } from "../../../_metronic/_partials/controls";
import { toAbsoluteUrl } from "../../../_metronic/_helpers";
import * as auth from "../Auth";
import { ProfileCard } from "./components/ProfileCard";
import * as Common from "../../General/common";
import { updateUserPasswordCall } from "../../services/userManagementService";
import { setUserPassword } from "../../../store/userPassword/actions";

function ChangePassword(props) {
  // Fields
  const [loading, setloading] = useState(false);
  const [isError, setisError] = useState(false);
  const [incorrectCurrentPassword, setIncorrectCurrentPassword] = useState(false);
  const [updating, setUpdating] = useState(false);
  const dispatch = useDispatch();
  const user = useSelector((state) => state.auth.user, shallowEqual);
  const userPassw = useSelector((store) => store.UserPassword.userPassw);
  const history = useHistory();
  
  useEffect(() => {}, [user]);
  // Methods

  const updatePassword = async (values) => {
    setUpdating(true);
    try {
     
        const { data } = await updateUserPasswordCall(values);
     
        if (data.success) {
            // success scenario 
            Common.showSuccessAlertAutoClose(
               "Password updated successfully!",
                "success",
                "Success!",
                3000
            );
            dispatch(setUserPassword(values.newPassword));
            history.replace("/dashboard");
           
        } else {
            Common.showSuccessAlertAutoClose(
                data.message,
                "warning",
                "Failed!",
                3000
            );
        }
    }
    catch {

        Common.showSuccessAlertAutoClose(
            "some error occured while processing your request",
            "warning",
            "Failed!",
            3000
        );
    }
    finally {
    
    }
    setUpdating(false);
}
  
  // UI Helpers
  const initialValues = {
    currentPassword: "",
    password: "",
    cPassword: "",
  };
  const Schema = Yup.object().shape({
    currentPassword: Yup.string()
    .required("Current password is required"),
    password: Yup.string()
    .min(8, "Minimum 8 symbols")
    .max(20, "Maximum 20 symbols")
    .required("New Password is required"),
    cPassword: Yup.string()
    .required("Password confirmation is required")
    .when("password", {
        is: (val) => (val && val.length > 0 ? true : false),
        then: Yup.string().oneOf(
          [Yup.ref("password")],
          "Password and Confirm Password didn't match"
        ),
      }),
  });
  const getInputClasses = (fieldname) => {
    if (formik.touched[fieldname] && formik.errors[fieldname]) {
      return "is-invalid";
    }

    if (formik.touched[fieldname] && !formik.errors[fieldname]) {
      return "is-valid";
    }

    return "";
  };
  const formik = useFormik({
    initialValues,
    validationSchema: Schema,
    onSubmit: (values, { setStatus, setSubmitting }) => {
      const dataToSubmit = {
        userId: user?.id,
        currentPassword: values.currentPassword,
        newPassword: values.password
      };
      if(dataToSubmit.userId > 0 && dataToSubmit.currentPassword && dataToSubmit.newPassword){
        if(formik.values.currentPassword !== userPassw){
          setIncorrectCurrentPassword(true);
          setSubmitting(false);
        }else{
          setIncorrectCurrentPassword(false);
          updatePassword(dataToSubmit);
          setSubmitting(false);
        }
      }
    },
    onReset: (values, { resetForm }) => {
      resetForm();
    },
  });

  return (
    <div className="d-flex flex-row">
    <ProfileCard />
    <div className="flex-row-fluid ml-lg-8">
    <form className="card card-custom" onSubmit={formik.handleSubmit}>
      {loading && <ModalProgressBar />}

      {/* begin::Header */}
      <div className="card-header py-3">
        <div className="card-title align-items-start flex-column">
          <h3 className="card-label font-weight-bolder text-dark">
            Change Password
          </h3>
          <span className="text-muted font-weight-bold font-size-sm mt-1">
            Change your account password
          </span>
        </div>
        <div className="card-toolbar">
          <button
            type="submit"
            className="btn btn-primary mr-2"
            disabled={
              formik.isSubmitting || (formik.touched && !formik.isValid) || updating
            }
          >
            <div className={`w-100 ${(formik.isSubmitting || updating) && 'pr-5'}`}>
            <span className={`${(formik.isSubmitting || updating) && 'mr-3'}`}>Save Changes</span>
            {(formik.isSubmitting || updating) && <span className="ml-3 m-auto spinner spinner-white"></span>}
            </div>
          </button>
          {/* <Link
            to="/user-profile/personal-information"
            className="btn btn-secondary"
          >
            <i class="fa fa-times mr-1"></i>Cancel
          </Link> */}
        </div>
      </div>
      {/* end::Header */}
      {/* begin::Form */}
      <div className="form">
        <div className="card-body">
          {/* begin::Alert */}
          {incorrectCurrentPassword && (
            <div
              className="alert alert-custom alert-light-danger fade show mb-10"
              role="alert"
            >
              <div className="alert-icon">
                <span className="svg-icon svg-icon-3x svg-icon-danger">
                  <SVG
                    src={toAbsoluteUrl("/media/svg/icons/Code/Info-circle.svg")}
                  ></SVG>{" "}
                </span>
              </div>
              <div className="alert-text font-weight-bold">
                The current password that you entered is incorrect!
              </div>
              <div className="alert-close" onClick={() => setisError(false)}>
                <button
                  type="button"
                  className="close"
                  data-dismiss="alert"
                  aria-label="Close"
                >
                  <span aria-hidden="true">
                    <i className="ki ki-close"></i>
                  </span>
                </button>
              </div>
            </div>
          )}
          {/* end::Alert */}
          <div className="form-group row">
            <label className="col-xl-3 col-lg-3 col-form-label text-alert">
              Current Password
            </label>
            <div className="col-lg-9 col-xl-6">
              <input
                type="password"
                placeholder="Current Password"
                className={`form-control form-control-lg form-control-solid mb-2 ${getInputClasses(
                  "currentPassword"
                )}`}
                name="currentPassword"
                {...formik.getFieldProps("currentPassword")}
              />
              {formik.touched.currentPassword &&
              formik.errors.currentPassword ? (
                <div className="invalid-feedback">
                  {formik.errors.currentPassword}
                </div>
              ) : null}
              {/* <a href="#" className="text-sm font-weight-bold">
                Forgot password ?
              </a> */}
            </div>
          </div>
          <div className="form-group row">
            <label className="col-xl-3 col-lg-3 col-form-label text-alert">
              New Password
            </label>
            <div className="col-lg-9 col-xl-6">
              <input
                type="password"
                placeholder="New Password"
                className={`form-control form-control-lg form-control-solid ${getInputClasses(
                  "password"
                )}`}
                name="password"
                {...formik.getFieldProps("password")}
              />
              {formik.touched.password && formik.errors.password ? (
                <div className="invalid-feedback">{formik.errors.password}</div>
              ) : null}
            </div>
          </div>
          <div className="form-group row">
            <label className="col-xl-3 col-lg-3 col-form-label text-alert">
              Verify Password
            </label>
            <div className="col-lg-9 col-xl-6">
              <input
                type="password"
                placeholder="Verify Password"
                className={`form-control form-control-lg form-control-solid ${getInputClasses(
                  "cPassword"
                )}`}
                name="cPassword"
                {...formik.getFieldProps("cPassword")}
              />
              {formik.touched.cPassword && formik.errors.cPassword ? (
                <div className="invalid-feedback">
                  {formik.errors.cPassword}
                </div>
              ) : null}
            </div>
          </div>
        </div>
      </div>
      {/* end::Form */}
    </form>
    </div>
    </div>
  );
}

export default connect(null, auth.actions)(ChangePassword);
